/**
 * Sarthi Mart delivery status card for cart page + cart drawer.
 * Informational only. Shopify checkout remains the source of truth for rates.
 */
(function () {
  var LOCAL_FREE_THRESHOLD = 25;
  var LOCAL_BELOW_CHARGE = 2.79;

  var UK_FREE_THRESHOLD = 75;
  var UK_BASE_CHARGE = 6.69;
  var SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

  var SPECIAL_ZONES = {
    zone_northern_ireland: {
      title: "Northern Ireland Delivery",
      courier: "Parcelforce / Royal Mail",
      time: "Estimated 2–5 days",
      max: 88,
      tiers: [[22, 12.79], [44, 25.58], [66, 38.37], [88, 51.16]]
    },
    zone_jersey: {
      title: "Jersey Delivery",
      courier: "Parcelforce / Royal Mail",
      time: "Estimated 2–5 days",
      max: 70,
      tiers: [[17.5, 10.00], [35, 20.00], [52.5, 30.00], [70, 40.00]]
    },
    zone_guernsey: {
      title: "Guernsey Delivery",
      courier: "DPD",
      time: "Estimated 2–8 days",
      max: 81,
      tiers: [[27, 22.00], [54, 38.00], [81, 54.00]]
    },
    zone_isle_of_man: {
      title: "Isle of Man Delivery",
      courier: "Parcelforce / Royal Mail",
      time: "Estimated 2–5 days",
      max: 88,
      tiers: [[22, 12.79], [44, 25.58], [66, 38.37], [88, 51.16]]
    },
    zone_highlands: {
      title: "Scottish Highlands & Islands Delivery",
      courier: "DPD",
      time: "Estimated 2–4 days",
      max: 82.5,
      tiers: [[27.5, 13.80], [55, 25.50], [82.5, 37.20]]
    }
  };

  function root() {
    return document.getElementById("sarthi-delivery-status");
  }

  function expired() {
    var checkedAt = parseInt(localStorage.getItem("delivery_checked_at") || "0", 10);
    return checkedAt ? (Date.now() - checkedAt) > SEVEN_DAYS_MS : false;
  }

  function money(v) {
    return "£" + Number(v).toFixed(2).replace(/\.00$/, "");
  }

  function kg(v) {
    return (Math.round(v * 100) / 100) + " kg";
  }

  function hideAll(el) {
    el.querySelectorAll(".sarthi-ds-card").forEach(function (card) {
      card.hidden = true;
    });
  }

  function setProgress(card, ratio) {
    var progress = card.querySelector(".sarthi-ds-progress");
    if (!progress) return;
    if (ratio === null) {
      progress.hidden = true;
      return;
    }
    progress.hidden = false;
    var fill = progress.querySelector(".sarthi-ds-progress__fill");
    if (fill) fill.style.width = Math.max(0, Math.min(ratio * 100, 100)) + "%";
  }

  function renderLocal(el, value) {
    var card = el.querySelector(".sarthi-ds-card--local");
    var free = value >= LOCAL_FREE_THRESHOLD;
    var charge = card.querySelector(".sarthi-ds-charge");
    if (charge) charge.textContent = free ? "FREE" : money(LOCAL_BELOW_CHARGE);
    setProgress(card, free ? null : value / LOCAL_FREE_THRESHOLD);

    var msg = card.querySelector(".sarthi-ds-message");
    if (msg) {
      msg.textContent = free
        ? "You have unlocked FREE Local Delivery."
        : "Add " + money(LOCAL_FREE_THRESHOLD - value) + " more for FREE Local Delivery.";
    }
    card.hidden = false;
  }

  function renderMainland(el, value, weightKg) {
    var card = el.querySelector(".sarthi-ds-card--courier");
    var contact = el.querySelector(".sarthi-ds-card--contact");
    var title = card.querySelector(".sarthi-ds-title");
    var msg = card.querySelector(".sarthi-ds-message");
    var note = card.querySelector(".sarthi-ds-weight-note");
    var timing = card.querySelector(".sarthi-ds-timing--courier");

    if (weightKg > 112) {
      contact.hidden = false;
      var cmsg = contact.querySelector(".sarthi-ds-message");
      if (cmsg) cmsg.textContent = "Orders over 112 kg cannot be accepted online for UK Mainland delivery. Please contact Sarthi Mart directly.";
      return;
    }

    if (title) title.textContent = "FREE UK Mainland Delivery over £75";
    setProgress(card, value / UK_FREE_THRESHOLD);

    if (value >= UK_FREE_THRESHOLD && weightKg <= 28) {
      var remaining = Math.max(0, 28 - weightKg);
      if (msg) msg.textContent = remaining > 0
        ? "You can add up to " + kg(remaining) + " more and keep FREE delivery."
        : "You've reached the 28 kg FREE delivery weight limit.";
    } else if (value >= UK_FREE_THRESHOLD) {
      if (msg) msg.textContent = "FREE delivery applies up to 28 kg; higher weights have an additional checkout charge.";
    } else {
      if (msg) msg.textContent = "Add " + money(UK_FREE_THRESHOLD - value) + " more to unlock FREE delivery up to 28 kg.";
    }

    if (note) {
      note.hidden = weightKg <= 28;
      note.textContent = weightKg > 28 ? "Weight charge is calculated at checkout for orders over 28 kg." : "";
    }
    if (timing) timing.textContent = "DPD UK Mainland • aim next working day • standard 2–4 working days";
    card.hidden = false;
  }

  function specialTier(config, weightKg) {
    for (var i = 0; i < config.tiers.length; i++) {
      if (weightKg <= config.tiers[i][0]) {
        return { max: config.tiers[i][0], charge: config.tiers[i][1] };
      }
    }
    return null;
  }

  function renderSpecial(el, zone, weightKg) {
    var config = SPECIAL_ZONES[zone];
    if (!config) return false;

    var card = el.querySelector(".sarthi-ds-card--courier");
    var contact = el.querySelector(".sarthi-ds-card--contact");
    var title = card.querySelector(".sarthi-ds-title");
    var msg = card.querySelector(".sarthi-ds-message");
    var note = card.querySelector(".sarthi-ds-weight-note");
    var timing = card.querySelector(".sarthi-ds-timing--courier");

    if (weightKg > config.max) {
      contact.hidden = false;
      var ctitle = contact.querySelector(".sarthi-ds-title");
      var cmsg = contact.querySelector(".sarthi-ds-message");
      if (ctitle) ctitle.textContent = config.title + " – Contact Us";
      if (cmsg) cmsg.textContent = "Orders over " + kg(config.max) + " require a custom delivery quote. Please contact Sarthi Mart directly.";
      return true;
    }

    var tier = specialTier(config, weightKg);
    if (title) title.textContent = config.title;
    setProgress(card, null);
    if (msg && tier) {
      msg.textContent = money(tier.charge) + " delivery for carts up to " + kg(tier.max) + ". No free-delivery threshold applies to this area.";
    }
    if (note) {
      note.hidden = false;
      note.textContent = "Your exact delivery charge is confirmed at checkout based on total cart weight.";
    }
    if (timing) timing.textContent = config.courier + " • " + config.time;
    card.hidden = false;
    return true;
  }

  function render(cart) {
    var el = root();
    if (!el) return;

    hideAll(el);

    var checked = localStorage.getItem("delivery_checked") === "yes";
    var zone = localStorage.getItem("delivery_zone") || "";

    el.hidden = false;

    if (!checked || !zone || zone === "blocked" || zone === "invalid" || expired()) {
      el.querySelector(".sarthi-ds-card--unknown").hidden = false;
      return;
    }

    var value = (cart.total_price || 0) / 100;
    var weightKg = (cart.total_weight || 0) / 1000;

    if (zone === "zone_1_local" || zone === "ZONE_1_LOCAL") {
      renderLocal(el, value);
      return;
    }

    if (renderSpecial(el, zone, weightKg)) return;

    if (zone === "zone_2_uk" || /^ZONE_[23]_/.test(zone)) {
      renderMainland(el, value, weightKg);
      return;
    }

    // Existing pending/legacy remote zones (including Isle of Wight) remain unchanged.
    el.querySelector(".sarthi-ds-card--unknown").hidden = false;
  }

  function refresh() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function (err) {
        console.error("[sarthi-delivery-status] cart fetch failed", err);
      });
  }

  ["cart:updated", "cart:refresh"].forEach(function (evt) {
    document.addEventListener(evt, refresh);
  });

  window.addEventListener("storage", function (event) {
    if (!event || !event.key || ["delivery_checked", "delivery_zone", "delivery_postcode"].indexOf(event.key) !== -1) {
      refresh();
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    refresh();

    var watchTargets = document.querySelectorAll(
      '#MinimogCart, [id*="cart-drawer"], [class*="cart-drawer"], cart-drawer, m-cart-items, [id*="CartDrawer"]'
    );
    if (watchTargets.length) {
      var timer;
      var observer = new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(refresh, 250);
      });
      watchTargets.forEach(function (t) {
        observer.observe(t, { childList: true, subtree: true });
      });
    }
  });
})();